import { Outlet } from 'react-router-dom';

import { WorkspaceShell, type BrandInfo } from '@saas-kit/ui/shell';

import { adminNav } from './nav';

const ADMIN_BRAND: BrandInfo = {
  initial: 'D',
  name: 'Donum Queues',
  subtitleKey: 'nav.platform_subtitle',
};

export function AdminShell(): JSX.Element {
  return (
    <WorkspaceShell
      brand={ADMIN_BRAND}
      brandTo="/"
      nav={adminNav}
      profilePath="/"
      signOutRedirect="/auth/login"
      collapsedKey="saas-kit.admin.sidebar.collapsed"
    >
      <Outlet />
    </WorkspaceShell>
  );
}
